import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--cancel" icon='cancel'>{ children ? children : 'Cancel' }</Button>
}